module.exports = __webpack_public_path__ + "h5/img/company_banner.798d6e1b.png";